import {React, styled} from 'common'
import {Images} from 'appearance'
import MenuItem from '@mui/material/MenuItem'
import UseLanguageButton from 'logic/Control/UseLanguageButton'

const LanaguageButton = ({isPopUp, language, close}) => {
    const {handleSetLanguage, availableLanguages, currentLanguage} =
        UseLanguageButton({close})

    if (isPopUp) {
        const displayLanguage = language?.toUpperCase()

        return (
            <MenuItem
                key={`lang_${language}`}
                onClick={() => handleSetLanguage(language)}>
                {displayLanguage}
                <FlagImage src={Images.FLAGS?.[displayLanguage]} />
            </MenuItem>
        )
    }

    return (
        <LanguagesList>
            {availableLanguages.map((lang) => {
                const language = currentLanguage?.toUpperCase()
                return (
                    <LangButton
                        key={`lang_${lang}`}
                        onClick={() => handleSetLanguage(lang)}>
                        {language}
                        <FlagImage src={Images.FLAGS?.[language]} />
                    </LangButton>
                )
            })}
        </LanguagesList>
    )
}

export default LanaguageButton

const FlagImage = styled.img`
    margin: 4px;
    width: 20px;
`
const LangButton = styled.div`
    cursor: pointer;
    display: flex;
`
const LanguagesList = styled.div`
    display: flex;
    flex-direction: row-reverse;
`
